import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { VolunteeringOverviewService } from '../volunteering-overview.service';

@Component({
	selector: 'volunteering-overview-views-part',
	standalone: true,
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overview-views.part.html',
})
export class VolunteeringOverviewViewsPart implements OnInit {

	public service = inject(VolunteeringOverviewService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}